import React from 'react';
import styles from './region-entity-table.module.scss';

export const RegionTableHeader = ({ region, comparing, isMobile }) => {
  return (
    <tr>
      <td colSpan={isMobile ? 1 : 2}>
        <div>
          <div>
            <span className={styles.tableHeaderText}>
              {comparing ? region.name : 'In this region'}
            </span>
          </div>
        </div>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/region-entity-table/region-table-header.js